import { Component, OnInit, Inject, ViewChild, AfterViewInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatStepper } from '@angular/material/stepper'
import { Actions, ofType } from '@ngrx/effects'
import { select, Store } from '@ngrx/store'
import {
  ConnectHopperSuccess,
  DisconnectHopperSuccess,
  GetHopperStatus,
  GetHopperListings,
  selectHopperStatus,
} from '@tokeet-frontend/channels'

import {
  Channel,
  DataCheckerService,
  Destroyable,
  LoadChannels,
  untilDestroy,
  UserStorage,
} from '@tokeet-frontend/tv3-platform'
import { WebsiteTemplateGuard } from '@tv3/guards/website-template.guard'
import { WebsiteGuard } from '@tv3/guards/website.guard'
import { LoadConnections } from '@tv3/store/connection/connection.actions'
import { delay, filter, switchMap, take } from 'rxjs/operators'
import { ChannelConnectHelperService } from '../channel-connect-helper.service'

@Component({
  selector: 'app-connect-hopper-wizard',
  templateUrl: './connect-hopper-wizard.component.html',
  styleUrls: ['./connect-hopper-wizard.component.scss'],
  host: {
    class: 'modal-content',
  },
  providers: [ChannelConnectHelperService],
})
export class ConnectHopperWizardComponent extends Destroyable implements OnInit, AfterViewInit {
  @ViewChild(MatStepper) stepper: MatStepper

  status$ = this.store.pipe(select(selectHopperStatus))

  get channel() {
    return this.data.channel
  }

  constructor(
    public dialogRef: MatDialogRef<ConnectHopperWizardComponent>,
    private actions: Actions,
    protected storage: UserStorage,
    private store: Store<any>,
    private checker: DataCheckerService,
    private channelConnectHelper: ChannelConnectHelperService,
    @Inject(MAT_DIALOG_DATA) public data: { channel: Channel }
  ) {
    super()
    this.checker.check([WebsiteGuard, WebsiteTemplateGuard])
  }

  ngOnInit(): void {
    this.actions.pipe(ofType(ConnectHopperSuccess), untilDestroy(this)).subscribe(() => {
      this.refresh()
    })

    this.actions.pipe(ofType(DisconnectHopperSuccess), untilDestroy(this)).subscribe(() => {
      this.store.dispatch(GetHopperStatus())
      this.store.dispatch(GetHopperListings())
      this.store.dispatch(LoadChannels())
      this.store.dispatch(LoadConnections({}))
    })
    this.channelConnectHelper.rentalImageCountsGuard().pipe(untilDestroy(this)).subscribe()

    this.refresh()
  }
  ngAfterViewInit(): void {
    this.stepper.animationDone
      .pipe(
        take(1),
        delay(500),
        switchMap(() => this.store.pipe(select(selectHopperStatus))),
        filter((s) => !!s?.connected),
        take(1),
        untilDestroy(this)
      )
      .subscribe((status) => {
        this.stepper.selectedIndex = 1
      })
  }

  close() {
    this.dialogRef.close()
  }

  refresh() {
    this.store.dispatch(GetHopperStatus())
    this.store.dispatch(GetHopperListings())
  }
}
